import { Database, FileQuestion, LockKeyhole, Search, TriangleAlert } from "lucide-react";
import type { ReactNode } from "react";

type EmptyStateVariant = "search" | "data" | "error" | "permission" | "notfound";

const glyphs = {
  search: Search,
  data: Database,
  error: TriangleAlert,
  permission: LockKeyhole,
  notfound: FileQuestion,
};

export function EmptyState({
  title,
  children,
  variant = "search",
  action,
}: {
  title: string;
  children: ReactNode;
  variant?: EmptyStateVariant;
  action?: ReactNode;
}) {
  const Glyph = glyphs[variant];

  return (
    <section className="card-hairline hero-paper overflow-hidden p-8 text-center">
      <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-[var(--radius-surface)] border border-border bg-surface-raised text-text-muted shadow-[var(--shadow-2)]">
        <Glyph aria-hidden="true" className="h-6 w-6" strokeWidth={1.5} />
      </div>
      <p className="page-eyebrow mt-6">ClearScope</p>
      <h2 className="section-title mt-3 font-semibold">{title}</h2>
      <div className="mx-auto mt-3 max-w-xl text-sm leading-6 text-text-muted">{children}</div>
      {action ? (
        <div className="mx-auto mt-6 flex max-w-xl justify-center border-t border-border pt-5">
          {action}
        </div>
      ) : null}
    </section>
  );
}
